import { apiConfig } from '../../../utils/apiConfig';
import { MediaAPI } from './MediaAPI';

export function useMediaAPI(): MediaAPI {
  return new MediaAPI(apiConfig);
}
